__turbopack_context__.v({
  "questionCheckbox": "styles-module-scss-module__tw0jyW__questionCheckbox",
  "questionCheckbox__card": "styles-module-scss-module__tw0jyW__questionCheckbox__card",
  "questionCheckbox__error": "styles-module-scss-module__tw0jyW__questionCheckbox__error",
  "questionCheckbox__errorSlot": "styles-module-scss-module__tw0jyW__questionCheckbox__errorSlot",
  "questionCheckbox__grid": "styles-module-scss-module__tw0jyW__questionCheckbox__grid",
});
